import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AccountPensionInformation } from '../../Models/Models/Account/AccountPensionInformation';

declare var IS_RUNNING_IN_APP_POOL;

export class AccountPensionInformationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string): Promise<AccountPensionInformation, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/AccountPensionInformation/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.get<AccountPensionInformation, any>(url, data);
  }
}

